export const FAQ_SECTION_STYLES = {
  root: "w-full",
  title: "text-[20px] md:text-[24px] font-bold text-ticketon-dark-text",
  description: "mt-2 text-[13px] text-ticketon-gray-600",
  list: "mt-4 flex flex-col gap-2",
  item: "group rounded-[12px] border border-ticketon-light-border bg-white shadow-ticketon-card",
  summary:
    "flex w-full cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 text-[14px] font-semibold text-ticketon-dark-text marker:hidden [&::-webkit-details-marker]:hidden",
  chevron:
    "text-[18px] leading-none text-ticketon-gray-alt transition-transform duration-200 group-open:rotate-45",
  answer: "px-5 pb-4 text-[13px] leading-relaxed text-ticketon-gray-600",
} as const;
